import { render, staticRenderFns } from "./Mixtos.vue?vue&type=template&id=5ba6d73c&"
import script from "./Mixtos.vue?vue&type=script&lang=js&"
export * from "./Mixtos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports